import React, { useEffect, useState } from 'react';
import {
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  FormControlLabel,
  Chip,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs, doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const urgencyLabels = {
  urgent: 'Urgente',
  soon: 'Próximas semanas',
  exploring: 'Explorando',
};

const AdminPanel = () => {
  const { currentUser, userRole, loading } = useAuth();
  const [messages, setMessages] = useState([]);
  const navigate = useNavigate();

  const fetchMessages = async () => {
    try {
      const q = query(collection(db, 'contactMessages'), orderBy('timestamp', 'desc'));
      const querySnapshot = await getDocs(q);
      setMessages(querySnapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (error) {
      console.error('AdminPanel: Error fetching messages:', error);
    }
  };

  useEffect(() => {
    if (!loading) {
      if (!currentUser || userRole !== 'admin') {
        navigate('/');
      } else {
        fetchMessages();
      }
    }
  }, [currentUser, userRole, loading, navigate]);

  const handleAttendedChange = async (messageId, currentStatus) => {
    try {
      await updateDoc(doc(db, 'contactMessages', messageId), {
        attended: !currentStatus,
      });
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, attended: !currentStatus } : msg
        )
      );
    } catch (error) {
      console.error('Error updating message status:', error);
    }
  };

  if (loading || !currentUser || userRole !== 'admin') {
    return (
      <Container maxWidth="md" sx={{ py: 14 }}>
        <Typography variant="h6" color="text.secondary" align="center">
          Cargando o acceso denegado...
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 12, md: 14 } }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
        Panel de administración
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Mensajes del formulario de contacto
      </Typography>
      {messages.length === 0 ? (
        <Typography>No hay mensajes de contacto.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Fecha</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Empresa</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Teléfono</TableCell>
                <TableCell>Servicio</TableCell>
                <TableCell>Urgencia</TableCell>
                <TableCell>Mensaje</TableCell>
                <TableCell>Atendido</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {messages.map((msg) => (
                <TableRow key={msg.id}>
                  <TableCell>
                    {msg.timestamp?.toDate?.()?.toLocaleString() || '—'}
                  </TableCell>
                  <TableCell>{msg.name}</TableCell>
                  <TableCell>{msg.company || '—'}</TableCell>
                  <TableCell>{msg.email}</TableCell>
                  <TableCell>{msg.phone || '—'}</TableCell>
                  <TableCell>{msg.serviceInterest || '—'}</TableCell>
                  <TableCell>
                    <Chip
                      label={urgencyLabels[msg.urgency] || msg.urgency || '—'}
                      size="small"
                      color={msg.urgency === 'urgent' ? 'error' : 'default'}
                    />
                  </TableCell>
                  <TableCell sx={{ maxWidth: 200 }}>{msg.message}</TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={msg.attended || false}
                          onChange={() => handleAttendedChange(msg.id, msg.attended || false)}
                        />
                      }
                      label={msg.attended ? 'Sí' : 'No'}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default AdminPanel;
